"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
exports.getValue = function (value, theme) {
    if (typeof value === 'number')
        return value;
    var values = Array.isArray(value) ? value : [value];
    var reducedValue = values
        .map(function (val) {
        if (typeof theme.modular.values[val] === 'undefined') {
            throw new Error("Modular System Error -> Value \"" + val + "\" is not set inside theme.modular.values object");
        }
        return theme.modular.values[val];
    })
        .reduce(function (acc, val) {
        var valFloat = typeof val === 'string' ? parseFloat(val) : val;
        var prev = typeof acc === 'string' ? parseFloat(acc) : acc;
        return prev + valFloat;
    });
    var averageValue = reducedValue / values.length;
    return averageValue;
};
exports.getRange = function (key, theme) {
    var range = typeof key === 'string' ? theme.modular.ranges[key] : key;
    if (Array.isArray(range)) {
        return range;
    }
    if (range.min && range.neutral && range.max) {
        return [range.min, range.neutral, range.max];
    }
    throw new Error('Modular System Error -> Range has to be a key of theme.modular.ranges or an array.');
};
exports.getHslValue = function (value, theme) {
    var hslValues;
    if (typeof value === 'number') {
        hslValues = {
            h: value,
            s: value,
            l: value
        };
    }
    else if (typeof value === 'string') {
        hslValues = {
            h: [value],
            s: [value],
            l: [value]
        };
    }
    else if (Array.isArray(value)) {
        hslValues = {
            h: value,
            s: value,
            l: value
        };
    }
    else {
        var h = value.h, s = value.s, l = value.l;
        if (!h || !s || !l) {
            throw new Error('Modular System Error -> HSL value object has to be similar to "{ h: ["weight"], s: ["roundness"], l: ["speed"] }".');
        }
        hslValues = {
            h: typeof h === 'number' ? h : Array.isArray(h) ? h : [h],
            s: typeof s === 'number' ? s : Array.isArray(s) ? s : [s],
            l: typeof l === 'number' ? l : Array.isArray(l) ? l : [l]
        };
    }
    var hueValue = exports.getValue(hslValues.h, theme);
    var saturationValue = exports.getValue(hslValues.s, theme);
    var lightnessValue = exports.getValue(hslValues.l, theme);
    return { h: hueValue, s: saturationValue, l: lightnessValue };
};
exports.getCubicBezierValue = function (value, theme) {
    var cbValues;
    if (typeof value === 'number') {
        cbValues = {
            x1: value,
            y1: value,
            x2: value,
            y2: value
        };
    }
    else if (typeof value === 'string') {
        cbValues = {
            x1: [value],
            y1: [value],
            x2: [value],
            y2: [value]
        };
    }
    else if (Array.isArray(value)) {
        cbValues = {
            x1: value,
            y1: value,
            x2: value,
            y2: value
        };
    }
    else {
        var x1 = value.x1, x2 = value.x2, y1 = value.y1, y2 = value.y2;
        if (!x1 || !x2 || !y1 || !y2) {
            throw new Error('Modular System Error -> CubicBezier value object has to be similar to "{ x1: ["weight"], y1: ["roundness"], x2: ["speed"], y2: ["speed"] }".');
        }
        cbValues = {
            x1: typeof x1 === 'number' ? x1 : Array.isArray(x1) ? x1 : [x1],
            y1: typeof y1 === 'number' ? y1 : Array.isArray(y1) ? y1 : [y1],
            x2: typeof x2 === 'number' ? x2 : Array.isArray(x2) ? x2 : [x2],
            y2: typeof y2 === 'number' ? y2 : Array.isArray(y2) ? y2 : [y2]
        };
    }
    var x1Value = exports.getValue(cbValues.x1, theme);
    var y1Value = exports.getValue(cbValues.y1, theme);
    var x2Value = exports.getValue(cbValues.x2, theme);
    var y2Value = exports.getValue(cbValues.y2, theme);
    return { x1: x1Value, y1: y1Value, x2: x2Value, y2: y2Value };
};
exports.useValue = function (key, transform) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    var value = exports.getValue(key, theme);
    return transform ? transform(value) : value;
};
//# sourceMappingURL=get.js.map